// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWebOrganisationLogoRequestModel from '../../model/get-web-organisation-logo-request-model';
import GetWebOrganisationLogoRequestDTO from '../dto/get-web-organisation-logo-request-dto';
import dtoSchema from '../schemas/get-web-organisation-logo-request-schema';

export default abstract class GetWebOrganisationLogoRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWebOrganisationLogoRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;

  static toModel(dto: DeepPartial<GetWebOrganisationLogoRequestDTO>): GetWebOrganisationLogoRequestModel;
  static toModel(dto: DeepPartial<GetWebOrganisationLogoRequestDTO> | undefined | null): GetWebOrganisationLogoRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWebOrganisationLogoRequestDTO> | undefined | null): GetWebOrganisationLogoRequestModel | undefined {
    return dto ? new GetWebOrganisationLogoRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWebOrganisationLogoRequestModel> | GetWebOrganisationLogoRequestModel): GetWebOrganisationLogoRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetWebOrganisationLogoRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWebOrganisationLogoRequestModel, can not map to GetWebOrganisationLogoRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
